<template>
  <el-container>
   
    <el-main style="margin:0px;padding:0px;padding-right:20px;">
      <el-container style="margin:0px;padding:0px;">
        <el-header style="margin:0px;padding:0px;padding-bottom:5px;height:30px;">
          <el-row type="flex" justify="end">
            <el-col :span="12">
              <el-link @click="$router.push({path:'/home/subject'})" style="font-size:16px;" :underline="false">我的病例库</el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link  style="font-size:16px;" :underline="false" type="primary">关注我的患者</el-link>
            </el-col>
            <el-col :span="12" style="text-align:right;padding-right:15px;">
              
              <el-dropdown @command="filter" trigger="click">
                <span class="el-dropdown-link">
                  <el-link :underline='false'>
                    <span v-if="this.filterbinder == 'binded'">
                      已建档
                    </span>
                    <span v-else-if="this.filterbinder == 'unbinded'">
                      未建档
                    </span>
                    <span v-else>
                      所有
                    </span>
                    <i class="el-icon-view el-icon--right" style="font-size:20px;"></i>
                  </el-link>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="all"> 
                    全部               
                  </el-dropdown-item>
                  <el-dropdown-item command="unbinded"> 
                    未建档                
                  </el-dropdown-item>
                  <el-dropdown-item command="binded"> 
                    已建档     
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </el-header>
        <el-main style="margin:0px;padding:0px;">
          <el-table :data="filterTableData" 
          :show-header="false" 
            @row-click="table_click" highlight-current-row>

            
            <el-table-column prop="nickname" label="微信昵称">
              <template slot-scope="scope">
                {{scope.row.nickname}} {{scope.row.subjectnumber}}
                <br>
                <i><span style="font-size:8pt">于 {{scope.row.createddate}} 关注</span></i>
              </template>
            </el-table-column>
      
            <el-table-column prop="subjectnumber" label="申请信息">
              <template slot-scope="scope">
                <el-link icon="el-icon-tickets" style="font-size:20px;" v-for="(item,index) in scope.row.weixinconsents" 
                         @click="showWeixinConsent(item.weixinconsentid)" :key="index" :underline="false" >
                  
                  <span style="font-size:16px;">{{item.formname}}</span>
                  <div style="font-size:8pt;">{{item.submitteddate}}</div>
                </el-link>
                
              </template>
            </el-table-column>

   
            <el-table-column label="操作" align="right" width="120px">
              <template slot-scope="scope">
                <span v-if="scope.row.subjectid || '' != ''" style="font-size:14px;">已建档</span>
                <span v-else><el-link icon="el-icon-connection" @click.stop="openSubjectEditor(scope.row)" type="primary" 
                :underline="false" style="font-size:20px;"><span style="font-size:14px">建档</span></el-link></span>

                
                <el-link icon="el-icon-chat-dot-round" @click.stop="showWeixinTalk(scope.row)"  
                :underline="false" style="font-size:20px;padding-left:5px"></el-link>

               
                
              </template>
            </el-table-column>
          </el-table>

          <el-drawer
            title="表单"
            size = "50%"
            :visible.sync="drawerForm"
            :with-header="false">
            <iframe ref="iframe" :src="viewUrl" frameborder="0" scrolling="yes" name="iframe" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
          </el-drawer>

          <el-drawer
            title="聊天框"
            size = "50%"
            :visible.sync="talk.drawer"
            :with-header="false">
            
                  <template>
                    <el-row style="text-align:left;height:30px;line-height:30px;padding-left:8px;">
                      <el-col>{{this.talk.to}}</el-col>
                    </el-row>

                    <div style=" overflow: hidden;">
                      <el-row>
                        <el-col :span="24" :offset="0">
                          <div
                            id="dataShow"
                            onmouseover="this.style.overflow='overlay'"
                            onmouseout="this.style.overflow='hidden'"
                            class="dataShow"
                          >
                            <div
                              v-for="(item,index) in talk.datalist"
                              :key="index"
                              style="background-color: #f5f5f5; padding:8px;"
                            >
                              <el-row v-if="item.sendertype =='PI'">
                                <el-col :span="20" :offset="2">
                                  <span style="float:right;font-size:8px;color:#fff;background-color:#dadada;">{{item.time}}</span><br>
                                  <span class="aa">
                                    {{ item.message }}
                                  </span>
                                </el-col>
                                <el-col :span="1" >
                                  <span> 
                                      <i class="el-icon-user" style="font-size: 30px" ></i>
                                  </span>
                                </el-col>
                              </el-row>
                            
                              <el-row v-if="item.sendertype =='SUB'">
                                <el-col :span="1">
                                  <span>       
                                      <i class="el-icon-s-custom" style="font-size: 30px" ></i>  
                                  </span>
                                </el-col>
                                <el-col :span="20">
                                  <span style="margin-left: 12px;font-size:8px;color:#fff;background-color:#dadada;">{{item.time}}</span><br>
                                  <span class="bb">
                                    {{ item.message }}
                                  </span>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>


                    <div>
                      <!-- <el-divider/> -->
                      <el-row>
                        <el-col :span="22" :offset="1">
                          <el-input
                            v-model="talk.message"
                            type="textarea"
                            autofocus
                            clearable
                            maxlength="100"
                            show-word-limit
                            :autosize="{minRows:3,maxRows:6}"
                            resize="none"
                            placeholder="在这里输入..."
                            @keyup.enter.native="sendMessage"
                          />
                        </el-col>
                      
                      </el-row>
                      <el-row style="margin: 4px 20px">
                        <el-button
                          style="border:0px solid #000;float:right;"
                          onmouseover="this.style.backgroundColor='#129611';this.style.color='#f5f5f5'"
                          onmouseout="this.style.backgroundColor='#f5f5f5';this.style.color='#606060'"
                          @click="sendMessage"
                        >
                          发送
                        </el-button>
                      </el-row>
                    </div>
                  </template>


          </el-drawer>
          

        </el-main>
      </el-container>
    </el-main>
    <el-aside width="250px" style="border-right: 0px solid #e7e9eb;
    position: relative;
    outline: none;
    color: #767c85;margin-top:20px;margin-bottom:20px;">
      <el-card class="box-card" style="margin-bottom:8px;">
        共计 {{filterTableData.length}} 个患者
      </el-card>

          
    </el-aside>
  </el-container>

</template>




<script>

export default {
    data() {
      return {
        weixinUserID:0,
        tableData: [],
        activityData:[],
        drawerForm:false,
        viewUrl:'',
        filterbinder:'unbinded',

        //聊天框
        talk:{
          drawer:false,
          datalist: [],
          visible: false,
          to:'',
          message:'',
          weixinuserid:'',
          subjectid:'',
        },

      }
    },
    created:function(){
      this.loadList();
    },
    computed: {
      filterTableData:function(){
        let filterTableData = this.tableData;
        filterTableData = filterTableData.filter(data => 
                                            this.filterbinder == 'all' || 
                                            (typeof(data.subjectid) != 'undefined' && this.filterbinder == 'binded') ||
                                            (typeof(data.subjectid) === 'undefined' && this.filterbinder == 'unbinded') 
                                            );
        return filterTableData;
      },
    },
    methods:{
      table_click(row,event,column){
        this.weixinUserID = row.subjectid;
        this.getWeixinInfo();
      },
      getWeixinInfo(){
        
      },
      loadList(){
        this.$http.get('weixinUser/list').then((res) => { 
          this.tableData = res.data.list;
        });
      },
      filter(command){
        this.filterbinder = command;
        // tableData.filter(data => this.filterbinder == 'all' || (data.subjectid || '' != '' && this.filterbinder == 'binded'))
      },
      
      openSubjectEditor(row){
        this.$router.push({name:'subject-new',query:{weixinuserid:row.weixinuserid,id:row.subjectid}});
      },


      showWeixinConsent(weixinconsentid, col, evt) {
        this.$http.get('weixinuser/showweixinconsent',{params:{id:weixinconsentid}}).then((res) => {
            if(!res) return;
            this.drawerForm = true;
            var view = res.data.view;
            window.formViewHtml = view;
            this.viewUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
            }); 
      },

      //聊天框
      showWeixinTalk(row){
        this.talk.to = row.nickname;
        this.talk.wxuserid = row.weixinuserid;
        this.talk.subjectid = row.subjectid;
        this.talk.drawer = true;

        this.getWeixinTalk();
      },
      getWeixinTalk(){
        this.$http.get('weixinuser/getweixinusertalk',
          {
            params:{
                      wxuserid:this.talk.wxuserid,
                   }
          }).then(res=>{
          if(!res) return;
            this.talk.datalist = res.data.list;
            this.scrollToBottom();
        });
      },
      clearBr(key) {
        key = key.replace(/<\/?.+?>/g, '')
        key = key.replace(/[\r\n]/g, '')
        return key
      },
      sendMessage(){
        this.talk.message = this.clearBr(this.talk.message)
        if (this.talk.message === '' || this.talk.message === undefined || this.talk.message === null) {
          this.$message.error('不能发送空白消息')
        }
        else{

          // var d = new Date()
          // let customerTime = d.getFullYear() + '-' + ((d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1))) +
          //   '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) +
          //   ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds())

          this.$http.post('weixinuser/sendweixinmessage',
            { 
              'message':this.talk.message,
              'wxuserid':this.talk.wxuserid,
              //'subjectid':this.talk.subjectid,
            })
          .then((res)=>{
            if(!res) return;
            
            this.talk.message = '';
            this.getWeixinTalk();

          });
        }

      },
      // 滚动到底部
      scrollToBottom() {
        this.$nextTick(() => {
          const div = document.getElementById('dataShow')
          div.scrollTop = div.scrollHeight
        })
      },

      // showWeixinForm(weixinformid, col, evt) {
      //   this.$http.get('weixinuser/showweixinform',{params:{id:weixinformid}}).then((res) => {
      //       if(!res) return;
      //       this.drawerForm = true;
      //       var view = res.data.view;
      //       window.formViewHtml = view;
      //       this.viewUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
      //       }); 
      // },

      
      
    }
  };
</script>

<style scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }

  

  iframe {
    width:100%;
    height:100%;
  }

    .font{
    font-size: 16px;
    font-weight: bold;
    font-family: "微软雅黑 Light";
  }
  .dataShow{
    overflow-y: hidden;
    overflow-x: hidden;
    margin-bottom: -24px;
    margin-top: -24px;
    height:2500px;
    margin-bottom: 1%;
    margin-top: 1%;
    background-color: #f5f5f5;
  }
  .aa{
    float: right;
    position: relative;
    display: inline-block;
    max-width: calc(40%);
    min-height: 35px;
    line-height: 2.1;
    font-size: 15px;
    padding: 10px 30px;
    text-align: left;
    word-break: break-all;
    background-color: #9eea6a;
    color: #000;
    border-radius: 4px;
    box-shadow: 0px 1px 7px -5px #000;
    border:0px solid #000;
    margin-top: 0;
    margin-right: 10px;
  }
  .aa:after {
    content: "";
    border-top: solid 5px #00800000;
    border-left: solid 10px #9eea6a;
    border-right: solid 10px #00800000;
    border-bottom: solid 5px #00800000;
    position: absolute;
    top: 10px;
    left: 100%;
  }
  .bb{
    display: inline-block;
    line-height:30px;
    font-style: normal;
    background-color: white;
    letter-spacing: 2px;
    position: relative;
    max-width: calc(40%);
    min-height: 35px;
    line-height: 2.1;
    font-size: 15px;
    padding: 10px 30px;
    text-align: left;
    word-break: break-all;
    border-radius: 4px;
    color: #000;
    box-shadow: 0px 1px 7px -5px #000;
    border:0px solid #000;
    margin-top: 0;
    margin-left: 50px;
  }
  .bb:after {
    content: "";
    border-top: solid 5px #00800000;
    border-left: solid 10px #00800000;
    border-right: solid 10px white;
    border-bottom: solid 5px #00800000;
    position: absolute;
    top: 10px;
    right: 100%;
 
  }
</style>